<template>
  <div>
    <VWidget
      v-if="order.customer"
      :title="$t('Customer')"
      class="mb-4"
    >
      <v-layout
        slot="widget-content"
        row
        wrap
        class="ma-0"
      >
        <v-flex xs12>
          <div class="info--text subheading">
            <router-link
              v-if="order.customer.customer_id"
              :to="{
                name: 'single_customer',
                params: { id: order.customer.customer_id }
              }"
            >
              {{ order.customer.firstname }}
              {{ order.customer.lastname }}
            </router-link>
            <template v-else>
              {{ order.customer.firstname }}
              {{ order.customer.lastname }}
            </template>
            <div class="info--text subheading">
              {{ order.customer.email }}
            </div>
            <div class="info--text subheading">
              {{ order.customer.telephone | telephone }}
            </div>
          </div>
          <div>1 Order</div>
        </v-flex>
      </v-layout>
    </VWidget>
    <VWidget
      :title="$t('Shipping Address')"
      class="mb-4"
    >
      <order-address-view
        v-if="order.shipping_address"
        slot="widget-content"
        :address="order.shipping_address"
      />
    </VWidget>
    <VWidget
      :title="$t('Billing Address')"
      class="mb-4"
    >
      <order-address-view
        v-if="order.billing_address"
        slot="widget-content"
        :address="order.billing_address"
      />
    </VWidget>
  </div>
</template>

<script>

import OrderAddressView from '@/modules/Orders/components/OrderAddressView'
export default {
  name: 'OrderSingleCustomer',
  components: { OrderAddressView },
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
